module.exports = "https://static.wmbcdn.com/uniweb/images/baa10bce1ab636951567f7f647c2b62b.svg";